export const baseUrl = "https://legha-glfunnel-backend-1001904334380.europe-west1.run.app/api/v1";
export const productName = "GL Funnel";
export const clientCompanyName = "Legha Foundation";
export const spinWheelUrl ="https://househuntrewards.in";
export const glPageUrl = "https://crm.glpages.s3-website.ap-south-1.amazonaws.com"